class VideoIframe {
  #videoIframe = null;
  #videoIframeLink = null;
  #video = null;
  constructor(videoIframe) {
    this.#videoIframe = videoIframe;
    this.#video= videoIframe;
    this.#videoIframeLink = videoIframe.querySelector('[rn-data-iframe-link]');
    this.init();
  }

  init() {

    this.#videoIframeLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.#videoIframeLink.classList.add('hidden');
    });
  }
}

const initVideosIframe = () => {
  const videosIframe = document.querySelectorAll('[rn-data-iframe]');
  if (videosIframe.length) {
    videosIframe.forEach((videoIframe) => {

      const videoIframeElement = new VideoIframe(videoIframe);
    })
  }
};

export { initVideosIframe };
